import { FormControl, FormLabel, FormErrorMessage, Button, Text } from '@chakra-ui/react';
import { Control, Path, useController } from 'react-hook-form';
import { useCallback, useRef } from 'react';

type FileProps<T = unknown> = {
  name: string;
  label?: string;
  acceptedFileTypes: string;
  placeholder?: string;
  isRequired?: boolean;
  control: Control<T>;
  fontSizeText?: string;
  classNameText?: string;
};

function FileUpload<T>({ name, placeholder, acceptedFileTypes, control, label, fontSizeText, classNameText, isRequired = false }: FileProps<T>) {
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    field: { ref, value, onChange, ...inputProps },
    fieldState: { invalid },
  } = useController({
    control,
    name: name as Path<T>,
    rules: { required: isRequired },
  });

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = e.target;
      if (files && files.length > 0) {
        onChange(files[0]);

        if (inputRef.current) {
          inputRef.current.value = '';
        }
      }
    },
    [onChange],
  );

  return (
    <FormControl isInvalid={invalid} isRequired>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <input type="file" accept={acceptedFileTypes} id={name} ref={inputRef} onChange={handleChange} {...inputProps} style={{ display: 'none' }} />
      <Button size="lg" variant="link" _hover={{ textDecoration: 'none' }} onClick={() => inputRef.current?.click()}>
        <Text fontSize={fontSizeText || 'xl'} fontWeight="semibold" color="#1D1D1D" fontFamily="Poppins" className={classNameText || ''}>
          {placeholder || 'Adicone uma imagem...'}
        </Text>
      </Button>
      <FormErrorMessage>{invalid}</FormErrorMessage>
    </FormControl>
  );
}

export { FileUpload };
